import React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// components
import NewUserModal from 'components/Modals/CreateUserModal'
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// constants
import { Modals } from 'constants/modals'

const CreateUserButton = () => {
  const { showModal } = useShowModal({ modalType: Modals.NEW_USER_MODAL })

  const onButtonClick = () => showModal()

  return (
    <>
      <Button onClick={onButtonClick} style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE}>
        Create User
      </Button>
      <NewUserModal />
    </>
  )
}

export default CreateUserButton
